import React from 'react';

interface RangeSliderProps {
  low: number;
  high: number;
  current: number;
  position: number; // e.g., 0.85
}

export const RangeSlider: React.FC<RangeSliderProps> = ({
  low,
  high,
  current,
  position,
}) => {
  // Convert 0.0-1.0 to 0%-100% for CSS absolute positioning. The backend
  // already clamped this, but Math.max/min guarantees the browser UI never
  // breaks.
  const leftPct = `${Math.min(Math.max(position * 100, 0), 100)}%`;

  // Fast native number formatting (e.g., 1,234.56).
  const formatPrice = (val: number) =>
    val.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  return (
    <div className="flex flex-col w-full min-w-[160px] text-xs">
      {/* High/Low Labels */}
      <div className="flex justify-between text-gray-500 mb-1.5 font-medium">
        <span>{formatPrice(low)}</span>
        <span>{formatPrice(high)}</span>
      </div>

      {/* The Track */}
      <div className="relative h-1.5 w-full bg-gray-200 dark:bg-gray-700 rounded-full">
        {/* The Marker (Dot) positioned securely by the Numba engine */}
        <div
          className="absolute top-1/2 -translate-y-1/2 w-2.5 h-2.5 bg-blue-600 dark:bg-blue-400 rounded-full shadow-sm transition-all duration-500"
          style={{ left: leftPct, transform: 'translate(-50%, -50%)' }}
          title={`Current: ${formatPrice(current)}`}
        />
      </div>
    </div>
  );
};
